import { UserAuthAction, authActionTypes } from "./UserAuthActions";
import { IUserAuthState, initialUserAuthState } from "./UserAuthState";

export const UserAuthReducer = (
  state: IUserAuthState = initialUserAuthState,
  action: UserAuthAction
): IUserAuthState => {
  const { type, payload } = action;
  switch (type) {
    case authActionTypes.LOGIN: {
      console.log(action);
      return { ...state, user: payload?.user, authorized: true };
    }

    case authActionTypes.LOGOUT: {
      console.log(action);
      return { ...state, user: undefined, authorized: false };
    }

    case authActionTypes.NOT_AUTHORISED: {
      console.log(action);
      return { ...state, authorized: false };
    }

    default:
      return state;
  }
};
